import React from "react";

function DeFiLotteryByXeer() {
  return (
    <div className="about-area pt-5 pb-5 mt-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 text-center">
            <div className="thumb pe-lg-5">
              <img
                src="/assets/img/illustration/2.png" // placeholder for laptop illustration
                alt="DeFi Lottery Development"
                style={{ maxWidth: "80%" }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className=" mt-4 mt-lg-0">
              <h2
                className="title split-lines mb-4"
                style={{ fontWeight: "bold" }}
              >
                DeFi Lottery Development By Xeer Technology
              </h2>
              <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}>
                With Xeer Technology, you can move ahead with a solid
                decentralized lottery platform that offers unmatched player
                visibility and absolute fairness. Our DeFi lottery solutions
                bring together provably fair mechanisms and automated jackpot
                distributions to your protocol, cultivating a highly rewarding
                lottery environment catalyzed by unshakeable trust and
                community-focused incentives at the center of the Web3
                expansion.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeFiLotteryByXeer;
